<template>
  <div class="write">
    <h2 class="page__title">글쓰기</h2>
    <form class="form" @submit.prevent>
      <div class="form__item">
        <label class="form__label">제목</label>
        <!-- [BUG FIX] input type="textarea" → input type="text" 로 수정 -->
        <input class="form__input" type="text" v-model="title" placeholder="제목을 입력하세요" />
      </div>
      <div class="form__item">
        <label class="form__label">내용</label>
        <!-- [BUG FIX] input type="textarea" → textarea 로 수정 -->
        <textarea class="form__textarea" v-model="content" placeholder="내용을 입력하세요" rows="6" />
      </div>
      <div class="form__item">
        <label class="form__label">태그</label>
        <!-- [BUG FIX] input type="textarea" → input type="text" 로 수정 -->
        <input class="form__input" type="text" v-model="tagdata" placeholder="#태그 (쉼표로 구분)" />
      </div>
      <div class="btn-wrap">
        <button class="btn btn--primary" type="button" @click="sendData">등록하기</button>
        <button class="btn btn--outline" type="button" @click="$router.go(-1)">취소</button>
      </div>
    </form>
  </div>
</template>

<script>
import instance from '../axiosInterceptor.js';

export default {
  name: 'writeContent',
  data() {
    return {
      title: '',
      content: '',
      tagdata: '',
      likecount: 0,
      filedataId: '',
    };
  },
  methods: {
    sendData() {
      if (!this.title || !this.content) {
        alert('제목과 내용을 입력해주세요.');
        return;
      }

      const data = {
        title: this.title,
        content: this.content,
        tagdata: this.tagdata,
        likecount: this.likecount,
        filedataId: this.filedataId,
      };

      instance
        .post(process.env.VUE_APP_API_SERVER_URL + '/api/writecontent', data)
        .then((response) => {
          if (response.status == 200 && response.data.retSuccessFail == 'SUCCESS') {
            this.$router.push('/afterLoginPage');
          } else {
            alert('글쓰기에 실패하였습니다.');
          }
        })
        .catch((error) => {
          console.error('글쓰기 실패:', error);
          alert('글쓰기 중 오류가 발생하였습니다.');
        });
    },
  },
};
</script>

<style scoped>
.write { padding-bottom: 4rem; }
</style>
